import { render, staticRenderFns } from "./Rs.vue?vue&type=template&id=459c5be4&scoped=true&"
import script from "./Rs.vue?vue&type=script&lang=js&"
export * from "./Rs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c5be4",
  null
  
)

export default component.exports